import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { FormattedDate } from 'react-intl';

import { DeliveryIcon } from '../../shared/SvgIcons';

import styles from './deliveryDate.scss';

export function DeliveryDate({ deliveryDateFrom, deliveryDateTo }) {
    return (
        <div styleName="wrapper">
            <div styleName="campaign-info">
                <DeliveryIcon />&nbsp;&nbsp;
                <FormattedDate value={deliveryDateFrom} day="2-digit" month="long" />
                &nbsp;-&nbsp;
                <FormattedDate value={deliveryDateTo} day="2-digit" month="long" />
            </div>
        </div>
    );
}

DeliveryDate.propTypes = {
    deliveryDateFrom: PropTypes.number.isRequired,
    deliveryDateTo: PropTypes.number.isRequired
};

export default CSSModules(DeliveryDate, styles);
